import axios from 'axios';

export default {
    get(context) {
        var options = {
            url: window.apiUrl + '/events',
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
  
    

};



// WEBPACK FOOTER //
// ./src/services/events/index.js